<template>
  <div id="page">
    <van-nav-bar
      title="2022天力百团千店一起赢"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
    </van-nav-bar>
    <div>
      <!-- <van-row>
        <div style="margin-top: 10px; float: right; margin-right: 5%">
          <van-button round size="mini" plain type="danger"
            >活动说明</van-button
          >
        </div>
      </van-row> -->
      <!--满足2单未成团之前可用-->
      <!-- <van-row>
        <div>
          <div style="margin: 10px; text-align: left">
            <van-notice-bar wrapable :scrollable="false" :text="noticeText" />
          </div>
          <div style="margin-top: 10px; width: 80%; margin-left: 10%">
            <van-button
              round
              size="normal"
              type="danger"
              block
              :disabled="show"
              @click="onTeamEdit"
              >我要成团</van-button
            >
          </div>
          <div style="margin-top: 10px; width: 80%; margin-left: 10%">
            <van-button
              round
              size="normal"
              type="danger"
              block
              :disabled="show"
              @click="onTeamSearch"
              >我要入团</van-button
            >
          </div>
        </div>
      </van-row> -->
      <!--团队信息 成团后显示-->
      <!-- <van-row>
        <div class="div1">
          <div
            style="
              height: 20%;
              margin-top: 10px;
              padding-top: 20px;
              font-size: 20px;
            "
          >
            我们的团名：{{ name }}<van-icon @click="updateTeam" name="edit" />
          </div>
          <div style="height: 20%">
            邀请倒计时：<van-count-down
              :time="time"
              format="DD 天 HH 时 mm 分 ss 秒"
            />
          </div>
          <div>
            <van-button
              round
              size="normal"
              type="danger"
              @click="onTeamInvite"
              :disabled="show2"
              >邀请好友入团</van-button
            >
          </div>
        </div>
      </van-row> -->
      <!--团成员信息 成团后显示-->
      <!-- <van-row>
        <div style="margin-bottom: 5%">
          <van-grid :gutter="10" :column-num="3" icon-size="2.5rem">
            <van-grid-item
              v-for="(item, idx) in memberList"
              v-bind:key="idx"
              icon="user-circle-o"
            >
              <div class="balance-text" slot="text">
                <div class="balance-name">
                  {{ item.IsTeamLeader == 1 ? "团长" : "团员" }}:{{
                    item.SDWorkerName
                  }}({{ item.Count }})
                </div>
                <div class="balance-value">
                  <van-button
                    v-if="item.IsTeamLeader == 0"
                    round
                    type="danger"
                    @click="cancelMember(item.SDWorkerId)"
                    size="mini"
                    >踢出</van-button
                  >
                </div>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </van-row> -->

      <div class="scroll-wrapper align-center" style="height: 100%; background-color: rgb(255, 255, 255); transform: translate(0px, 0px) translateZ(0px);">
        <div class="e-page-bg-image" style="opacity: 1; height: 100%;">
          <img src="../assets/team1/logo.jpg" fit="contain" width="100%" style="opacity: 1; height: 100%;">
        </div>
        <div class="page-content" style="width: 376px; height: 100%; overflow: hidden;">
          <van-row style="height:31px;margin-top:480px;">
            <div class="cmp cmp-image" data-id="1630318985554130" data-type="image" 
            style="width: 130px; height: 31px; left: 32%; margin-top: 38.5px; position: absolute;">
              <div class="animate-wrapper" data-id="1630318985554130" style="border-radius: 0px; box-shadow: transparent 0px 0px 10px;">
                <div class="image" style="opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 0px;">
                  <img class="inner-image" src="../assets/team1/94a877e9-5744-47a2-babd-f4c8cb1c4cb0.webp.jpg" @click="onTeamAct">
                </div>
              </div>
            </div>
          </van-row>

          <van-row style="height:50px;margin-top:10%;">
            <div class="cmp cmp-image" data-id="163030691278020" data-type="image" 
            style="width: 90%; height: 28px; margin-left: 5%; margin-top: 10px; position: absolute;">
              <div class="animate-wrapper" data-id="163030691278020" style="border-radius: 0px; box-shadow: transparent 0px 0px 10px;">
                <div class="image" style="opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 0px;">
                  <img class="inner-image" src="../assets/team1/4c584f55-e35b-4020-abd2-6df87d6137dc.webp.jpg">
                </div>
              </div>
            </div>
            <div class="cmp cmp-pluginComponent" data-id="163089782963714" data-type="pluginComponent" 
            style="width: 90%; height: 27px; margin-left: 5%; margin-top: 10px; position: absolute;">
              <div class="animate-wrapper" data-id="163089782963714" style="border-radius: 14px;">
                <div class="plugin-container">
                  <div class="component-message-carousel-app__32Tma" 
                  style="transform: rotate3d(0, 0, 1, 0deg); opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 14px; width: 100%; height: 27px; left: 0px; top: 0px; background-color: transparent; overflow: hidden; display: block; position: relative;">
                    <div class="component-message-carousel-scroll-box__37rHX">
                      <div class="component-message-carousel-scroll-list__AcmNY">
                        <div class="component-message-carousel-item__1Q7h_" style="width: 100%; height: 27px; margin-bottom: 9px;">
                          <div class="component-message-carousel-text__VLnWw component-message-carousel-text__1mh8z" 
                          style="transform: rotate3d(0, 0, 1, 0deg); opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 0px; width: 100%; height: 25px; left: 1px; color: rgb(51, 51, 51); font-size: 10px; font-family: normal; font-style: normal; font-weight: 400; text-align: center; padding-top:5px;text-decoration: none; line-height: 15px; letter-spacing: 0px; background-color: transparent; position: absolute; top: 2px;">
                            <span class="label">{{ noticeText }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-row>

          <van-row style="height:50px;">
            <div class="cmp cmp-pluginComponent" data-id="16296975450186" data-type="pluginComponent" 
            style="width: 104px; height: 27px; margin-left: 35%; margin-top: 10px; position: absolute;">
              <div class="animate-wrapper" data-id="16296975450186" style="border-radius: 20px;">
                <div class="plugin-container">
                  <button type="button" class="component-team-create-button-button__18D8d component-team-create-button-app__3YwtP" 
                style="transform: rotate3d(0, 0, 1, 0deg); opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 20px; width: 104px; height: 27px; left: 0px; top: 0px; position: relative; color: rgb(255, 255, 255); font-size: 15px; font-weight: 600; box-shadow: transparent 0px 0px 10px; display: block;" 
                :disabled="show" @click="onTeamJoin">
                  <img class="image" src="../assets/team1/a6fe8bd1-39aa-479a-8b11-984ab9eb5bed.webp.jpg">
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="cmp cmp-pluginComponent" data-id="16296975450186" data-type="pluginComponent" 
            style="width: 104px; height: 27px; margin-left: 20%; margin-top: 10px; position: absolute;">
              <div class="animate-wrapper" data-id="16296975450186" style="border-radius: 20px;">
                <div class="plugin-container">
                  <button type="button" class="component-team-create-button-button__18D8d component-team-create-button-app__3YwtP" 
                style="transform: rotate3d(0, 0, 1, 0deg); opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 20px; width: 104px; height: 27px; left: 0px; top: 0px; position: relative; color: rgb(255, 255, 255); font-size: 15px; font-weight: 600; box-shadow: transparent 0px 0px 10px; display: block;" 
                :disabled="show" @click="onTeamEdit">
                  <img class="image" src="../assets/team1/02cde094-565f-40cb-9172-655b61bc461d.webp.jpg">
                  </button>
                </div>
              </div>
            </div>
            <div class="cmp cmp-btn" data-id="162969771525119" data-type="btn" 
            style="width: 104px; height: 27px; margin-left: 55%; margin-top: 10px; position: absolute;">
              <div class="animate-wrapper" data-id="162969771525119" style="border-radius: 20px; box-shadow: transparent 5px 5px 10px;">
                <button class="btn" type="button" style="opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 20px; color: rgb(255, 255, 255); font-size: 12px; text-align: center;" 
                :disabled="show" @click="onTeamSearch">
                  <img class="image" src="../assets/team1/a6fe8bd1-39aa-479a-8b11-984ab9eb5bed.webp.jpg">
                </button>
              </div>
            </div> -->
          </van-row>
          
          <!--已成立团-->
          <div v-if="team.TeamName!=null">
            <van-row style="height:270px;">
              <div class="cmp cmp-pluginComponent" data-id="162565069461322" data-type="pluginComponent" 
              style="width: 90%;height: 257px;margin-left: 5%;margin-top: 10px;position: absolute;">
                <div class="animate-wrapper" data-id="162565069461322" style="border-radius: 7px">
                  <div class="plugin-container">
                    <div class="component-team-list-app__3ay0S" 
                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 7px;width: 100%;height: 257px;left: 0px;top: 0px;background-color: rgb(255, 255, 255);display: block;position: relative;">
                      <div class="component-team-list-rect__2HIBd" 
                      style="transform: translate3d(0px, 0px, 0px)">
                        <div class="component-team-list-swiper-wrapper__1Onag" 
                        style="background-color: rgb(247, 222, 126); border-radius: 7px; left: 0px;">
                          <div class="component-team-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 100%;height: 17px;left: 12px;color: rgb(51, 51, 51);font-size: 15px;font-family: normal;font-style: normal;font-weight: 400;text-align: center;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 10px;word-break: break-all;font-weight:bold;">
                            我们的团名：{{ name }}
                            <van-icon @click="updateTeam" name="edit" />
                            <!-- <van-tag round type="primary" style="margin-left:10px;" @click="quitTeam()">退团</van-tag> -->
                          </div>
                          <!-- <div v-if="num > 0" class="component-team-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 120px;height: 17px;left: 14px;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: left;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 50px;word-break: break-all;">
                            还差<span class="component-team-list-emphasize-number__1Yurg">{{ num }}</span>人组团成功
                          </div> -->
                          <div v-if="num > 0" class="component-team-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 120px;height: 17px;left: 14px;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: left;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 30px;word-break: break-all;">
                            还差<span class="component-team-list-emphasize-number__1Yurg">{{ num }}</span>人组团成功
                          </div>
                          <div v-else class="component-team-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 120px;height: 17px;left: 14px;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: left;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 30px;word-break: break-all;">
                            恭喜组团成功
                          </div>
                            <div v-if="memberList.length == 5">
                              <ul class="component-team-list-list__2UyMq">
                                <li class="component-team-list-item__2bK-K"  v-for="(item, idx) in memberList" v-bind:key="idx">
                                  <img alt="队伍成员头像" src="../assets/team1/4ab49b3e-e26d-4f9f-b28d-3eb0603118e3.webp.jpg" class="component-team-list-image__2eOAP"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 22px;width: 41px;height: 41px;box-shadow: transparent 0px 0px 10px;position: absolute;left: 4px;top: 0px;"/>
                                  <div class="component-team-list-text__VLnWw"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 50px;height: 17px;left: 0px;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: center;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 48px;">
                                    <span class="label">{{item.SDWorkerName }}</span>
                                    <div style="margin-top:5px;">
                                      <!-- <van-button round type="primary" size="mini" 
                                      v-if="item.IsTeamLeader == 1"
                                      @click="onTeamTransfer(item.TeamId)">转出
                                      </van-button> -->
                                      <van-button round type="danger" size="mini" 
                                      v-if="item.IsTeamLeader == 0"
                                      @click="cancelMember(item.SDWorkerId)">踢出
                                      </van-button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div v-else>
                              <ul class="component-team-list-list__2UyMq">
                                <li class="component-team-list-item__2bK-K"  v-for="(item, idx) in memberList" v-bind:key="idx">
                                  <img alt="队伍成员头像" src="../assets/team1/4ab49b3e-e26d-4f9f-b28d-3eb0603118e3.webp.jpg" class="component-team-list-image__2eOAP"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 22px;width: 41px;height: 41px;box-shadow: transparent 0px 0px 10px;position: absolute;left: 4px;top: 0px;"/>
                                  <div class="component-team-list-text__VLnWw"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 50px;height: 17px;left: 0px;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: center;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 48px;">
                                    <span class="label">{{item.SDWorkerName }}</span>
                                    <div style="margin-top:5px;">
                                      <van-button round type="danger" size="mini" 
                                      v-if="item.IsTeamLeader == 0"
                                      @click="cancelMember(item.SDWorkerId)">踢出
                                      </van-button>
                                    </div>
                                  </div>
                                </li>
                                <li class="component-team-list-item__2bK-K" v-for="index of num" v-bind:key="index">
                                  <img alt="待邀请队员头像" src="../assets/team1/891c840a-ccab-4d48-b15b-dd31614c2d48.webp.jpg" class="component-team-list-image__2eOAP"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 22px;width: 41px;height: 41px;box-shadow: transparent 0px 0px 10px;position: absolute;left: 4px;top: 0px;"/>
                                  <div class="component-team-list-text__VLnWw"
                                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 50px;height: 17px;left: 0px;color: rgb(102, 102, 102);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: center;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 48px;">
                                    <span class="label">待加入</span>
                                  </div>
                                </li>
                              </ul>
                          </div>
                          
                          <div style="font-size:10px;margin-top:40px;text-align:center;">
                            <van-count-down :time="time" format="DD天HH时mm分ss秒" />
                          </div>
                          <button type="button" class="component-team-list-button__18D8d" 
                          style="opacity: 1; border-style: solid; border-width: 0px; border-color: rgb(0, 0, 0); border-radius: 20px; box-shadow: transparent 5px 5px 10px; font-size: 15px; text-align: center; background-color: rgb(248, 174, 33); position: absolute; width: 265px; height: 38px; color: rgb(255, 255, 255); font-weight: 600; transform: rotate3d(0, 0, 1, 0deg); margin-top: 5px; left: 12%;" 
                          @click="onTeamInvite"
                          :disabled="show2">
                            <span class="label">邀请好友组队</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-row>

            <van-row style="height:300px;">
              <div class="cmp cmp-pluginComponent" data-id="162693696935699" data-type="pluginComponent"
                style="width: 90%;height: 280px;margin-left: 5%;margin-top: 10px;position: absolute;">
                <div class="animate-wrapper" data-id="162693696935699" style="border-radius: 7px">
                  <div class="plugin-container">
                    <div class="component-answer-ranking-list-scroll-view-container__1nM8c component-answer-ranking-list-wrapper__2jfrL"
                      style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 7px;width: 100%;height: 280px;left: 0px;top: 0px;background-color: rgb(255, 242, 118);display: block;position: relative;">
                      <ul class="component-answer-ranking-list-list__2yquV">
                        <li class="component-answer-ranking-list-item__3LSNV" data-key="0">
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 25%;height: 19px;left: 2%;color: rgb(51, 51, 51);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: center;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            水工姓名
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw component-answer-ranking-list-single-ellipsis__2w3_K"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 28%;height: 17px;left: 28%;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: left;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 14px;">
                            <span class="label">水工电话</span>
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 20%;height: 19px;left: 50%;color: rgb(224, 47, 36);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: right;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            带单
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 20%;height: 19px;left: 75%;color: rgb(224, 47, 36);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: right;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            个人奖励
                          </div>
                        </li>
                        <li class="component-answer-ranking-list-item__3LSNV" v-for="(item, idx) in memberList" v-bind:key="idx">
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 25%;height: 19px;left: 2%;color: rgb(51, 51, 51);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: center;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            {{ item.SDWorkerName }}
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw component-answer-ranking-list-single-ellipsis__2w3_K"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 28%;height: 17px;left: 28%;color: rgb(51, 51, 51);font-size: 12px;font-family: normal;font-style: normal;font-weight: 400;text-align: left;text-decoration: none;line-height: 17px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 14px;">
                            <span class="label">{{ item.SDWorkerTel }}</span>
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 20%;height: 19px;left: 50%;color: rgb(224, 47, 36);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: right;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            {{ item.Count }}
                          </div>
                          <div class="component-answer-ranking-list-text__VLnWw"
                            style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 0px;width: 20%;height: 19px;left: 75%;color: rgb(224, 47, 36);font-size: 14px;font-family: normal;font-style: normal;font-weight: 600;text-align: right;text-decoration: none;line-height: 19px;letter-spacing: 0px;background-color: transparent;position: absolute;top: 13px;">
                            {{ item.Reward }}
                          </div>
                        </li>
                        
                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </van-row>

          </div>
          <!--未成立团-->
          <div v-else>
            <van-row style="height:270px;">
              <div class="cmp cmp-pluginComponent" data-id="162565069461322" data-type="pluginComponent" 
              style="width: 90%;height: 257px;margin-left: 5%;margin-top:10px;margin-bottom: 10px;position: absolute;">
                <div class="animate-wrapper" data-id="162565069461322" style="border-radius: 7px">
                  <div class="plugin-container">
                    <div class="component-team-list-app__3ay0S" 
                    style="transform: rotate3d(0, 0, 1, 0deg);opacity: 1;border-style: solid;border-width: 0px;border-color: rgb(0, 0, 0);border-radius: 7px;width: 100%;height: 257px;left: 0px;top: 0px;background-color: rgb(255, 242, 118);display: block;position: relative;">
                      <div class="component-team-list-rect__2HIBd" 
                      style="transform: translate3d(0px, 0px, 0px)">
                        <div class="component-team-list-swiper-wrapper__1Onag" 
                        style="background-color: rgb(247, 222, 126); border-radius: 7px; left: 0px;">
                          <div class="component-team-list-placeholder__-bp2V">
                            <img src="../assets/team1/54a71622-ec95-417f-bb9f-e2d274727ce6.webp.jpg" alt="占位符图片" />
                            <p>你还没有创建过队伍哦～</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-row>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button,
  NavBar,
  Row,
  Icon,
  CountDown,
  GridItem,
  Grid,
  Divider,
  NoticeBar,
  Dialog,
  Tag,
} from "vant";
export default {
  data() {
    return {
      processNum: 0,
      noticeText: "",
      memberList: [],
      team: {},
      // IsMyTeam: 0,
      show: true,
      time: 0,
      show2: true,
      name: "",
      num: 0,
      TotalCount: 0,
      // TeamReward: 0,
      // DiffCount: 0,
      teamNoticeText: ""
    };
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    getProcessNum() {
      var that = this;
      that.$http.get("SDWorker/GetSDWorkerCountByTel").then((res) => {
        that.processNum = res.data.Data.count;
        var text = "您当前累计带单 " + that.processNum;
        if (that.processNum == 0 || that.processNum < 2) {
          text = text + " 单，达到2单可参加2022年下半年成团活动";
        }
        if (that.processNum >= 2) {
          text = text + "单，可参加2022年下半年成团活动";
          that.show = !that.show;
        }
        that.noticeText = text;
      });
    },
    getTeam() {
      var that = this;
      that.$http.get("Team/QueryMyTeam").then((res) => {
        that.time = res.data.Data.Time;
        that.memberList = res.data.Data.TeamDetail;
        that.num = 5 - that.memberList.length;
        that.team = res.data.Data.Team;
        // that.IsMyTeam = res.data.Data.IsMyTeam;
        // that.TotalCount = res.data.Data.TotalCount;
        // that.TeamReward = res.data.Data.TeamReward;
        // that.DiffCount = res.data.Data.DiffCount;
        // var text = "成团累计完成"+that.TotalCount+"单可获得"+that.TeamReward+"积分，距下一阶段奖励还差"+that.DiffCount+"单";
        // that.teamNoticeText = text;
        if (res.data.Data.Team.TeamName != null) {
          that.name = res.data.Data.Team.TeamName;
        }
        if (that.name != "") {
          that.show = true;
        }
        if (that.time > 0 && that.num > 0) {
          that.show2 = !this.show;
        }
      });
    },
    onTeamAct() {
      this.$router.push({
        name: "activity",
        params: {},
      });
    },
    onTeamSearch() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamSearch",
        params: {},
      });
    },
    onTeamEdit() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamEdit",
        params: { update: 0 },
      });
    },
    updateTeam() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      if (this.IsMyTeam == 0) {
        return this.$toast.fail("您不是团长哦~");
      }
      this.$router.push({
        name: "TeamEdit",
        params: { update: 1 },
      });
    },
    onTeamInvite() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamInvite",
        params: {},
      });
    },
    onTeamTransfer(teamId) {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamTransfer",
        params: {teamId:teamId},
      });
    },
    // 踢出
    cancelMember(SDWorkerId) {
      console.log(SDWorkerId);
      var that = this;
      that.$http.get("Team/CancelPeople?sdworkerId="+SDWorkerId,).then(res=>{
        if(res.data=='success'){
          that.$toast("踢人申请已提交，请等待其他两名团员通过！");
        }else{
          that.$toast(res.data);
        }
      });
    },
    // 退团 
    quitTeam() {
      var that = this;
      Dialog.confirm({
        title: "退团",
        message:
          "是否确认退出该团，退出后无法计算全年排名奖励?",
      })
        .then(() => {
          // on confirm
          that.$http.get("Team/QuitTeam", {
            params: {
              teamId:that.team.ID
            },
          })
          .then((res) => {
            if (res.data == "success") {
              that.$toast("退团成功！");
              that.getTeam();
            } else {
              that.$toast(res.data);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 系统分配入团
    onTeamJoin() {
      var that = this;
      Dialog.confirm({
        title: "入团",
        message:
          "是否确认系统随机分配入团，入团成功后无法退出?",
      })
        .then(() => {
          // on confirm
          that.$http
          .get("Team/JoinTeam", {
            params: {},
          })
          .then((res) => {
            if (res.data == "success") {
              that.$toast("随机分配团队成功！");
              // that.getProcessNum();
              that.getTeam();
            } else {
              that.$toast(res.data);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Divider.name]: Divider,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
  },
  created() {
    this.getProcessNum();
    this.getTeam();
  },
};
</script>
<style scoped>
/* html {
  background: #f12416;
} */
#page {
  width: 100%;
  height: 100%;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}

.div1 {
  /* width:90%;
  height:200px;
  border:1px solid red;
  border-radius:20px;
  text-align: center;
  float:center; 
  margin: 10px 5% 10px 5%; */
  margin: 20px 0px 0px 0px;
  width: 100%;
  height: 255px;
  background-image: url("../assets/team2.png");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.balance-text {
  margin-top: 0;
  font-size: 13px;
}
.balance-name {
  color: #666;
  margin-top: 5px;
}
.balance-value {
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
  color: #b00;
}

.aui-take-item {
  background: #fff;
  border-radius: 5px;
  margin: 1rem;
}

.aui-flex {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 15px;
  position: relative;
}

.aui-flex-box {
  -webkit-box-flex: 1;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}

div, img{
    font-size: 100%;
    vertical-align: initial;
    background: transparent;
    outline: none;
}

img {
    user-select: none;
}

.cmp.cmp-image .image .inner-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    outline: 1px solid transparent;
}
.cmp .animate-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.cmp.cmp-image .image {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.cmp.cmp-pluginComponent>.animate-wrapper {
    overflow: visible;
}

.cmp .animate-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.plugin-container{
  position: relative!important;
  display: block!important;
  width: 100%!important;
  height: 100%!important;
}

.component-team-list-app__3ay0S{
  box-sizing: border-box;
  overflow: hidden;
  background-color: initial!important;
  border-radius: 0px !important;
}

.component-team-list-rect__2HIBd{
  position: absolute;
}
.component-team-list-rect__2HIBd{
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  height: 252px;
  border-radius: 7px;
}

.component-team-list-placeholder__-bp2V{
  position: absolute;
  margin-top: 80px;
  width: 170px;
  height: 128px;
  text-align: center;
}

.component-team-list-placeholder__-bp2V, .component-team-list-placeholder__-bp2V img{
  left: 50%;
  transform: translateX(-50%);
}

.component-team-list-placeholder__-bp2V img{
  position: relative;
  display: block;
  width: 98px;
  height: 82px;
  margin: 0;
}

.component-team-list-placeholder__-bp2V p{
  width: 100%;
  margin-top: 29px;
  color: #666;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
}




.component-team-list-progress-navigation-bar__1QbED, .component-team-list-slider__30gT4, .component-team-list-swiper-wrapper__1Onag {
    position: absolute;
}

.component-team-list-swiper-wrapper__1Onag {
    width: 100%;
    height: 100%;
}

/* .component-team-list-list__2UyMq {
    margin-top: 79px;
    margin-left: 3%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 94%;
    height: 65px;
} */
.component-team-list-list__2UyMq {
    margin-top: 59px;
    margin-left: 3%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 94%;
    height: 65px;
}

.component-team-list-item__2bK-K {
    position: relative;
    width: 50px;
    height: 100%;
    list-style: none;
}

.component-team-list-button__18D8d {
    overflow: hidden;
    background: none;
    border: none;
    outline: none;
    appearance: none;
}

.component-team-list-image__2eOAP {
    object-fit: cover;
    outline: transparent solid 1px;
    backface-visibility: hidden;
}

.component-team-list-item__2bK-K div {
    white-space: nowrap;
    word-break: break-all;
}

.component-team-list-button__18D8d > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
}

.component-team-list-emphasize-number__1Yurg {
    margin: 0px 2px;
    color: rgb(213, 21, 21);
    font-size: 12px;
}


.cmp.cmp-countdown .countdown-wrapper {
    overflow: hidden;
    height: 100%;
    flex-wrap: nowrap;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}

.countdownblock {
    width: 19%;
    min-width: 6px;
    height: auto;
    margin: 6px;
    padding: 1px 0;
}

.countdownblock .block-wrapper .c-num {
    display: inline-block;
    overflow: hidden;
    width: 50%;
    font-size: 27px;
}

.countdownblock .block-wrapper .c-text {
    display: flex;
    width: 100%;
    margin-top: 2px;
    font-size: 14px;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
}

.countdownblock .block-wrapper .c-num.left .flex-wrapper {
    -webkit-box-pack: end;
    justify-content: flex-end;
}

.countdownblock .block-wrapper .c-num .flex-wrapper .next-value {
    position: absolute;
    top: -100%;
    opacity: 1;
    line-height: 27px;
}

.countdownblock .block-wrapper .c-num .flex-wrapper .curr-value {
    line-height: 27px;
}

.cmp.cmp-countdown * {
    transform: translateZ(0);
}

.cmp.cmp-btn button {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: none;
    border: none;
    outline: none;
    appearance: none;
    word-break: break-all;
}

.component-team-create-button-button__18D8d > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
}

.cmp.cmp-btn img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
}

.component-team-create-button-button__18D8d {
    overflow: hidden;
    background: none;
    border: none;
    outline: none;
    appearance: none;
}

.scroll-wrapper {
    display: flex;
    overflow: hidden;
    width: 100%;
}

.e-page-bg-image, .e-page-bg-image img {
    position: absolute;
}
.e-page-bg-image {
    top: 0;
    left: 0;
    width: 100%;
}



.component-answer-ranking-list-item__3LSNV:not(:last-child) {
    border-bottom: 1px solid #eee;
}
.component-answer-ranking-list-item__3LSNV {
    position: relative;
    height: 45px;
}
</style>
